<template>
  <div>
    <ag-grid-vue ref="agGridTablee" :gridOptions="gridOptions" :key="count"
      class="ag-theme-material w-100 my-4 ag-grid-table ap_ag_grid acu_dashboard_tbl"
      :class="{ opacity_resize: opacity_table }" :columnDefs="headers" :defaultColDef="defaultColDef"
      :rowData="computedItems" colResizeDefault="shift" domLayout="autoHeight" @grid-ready="onGridReady"
      :enableRtl="$vs.rtl" @cell-clicked="onCellClicked" :suppressDragLeaveHidesColumns="true"
      :suppressAggFuncInHeader="true" :suppressPaginationPanel="true" :suppressRowClickSelection="true"
      :pagination="true" @column-moved="moved">
    </ag-grid-vue>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import CellRendererAcuActions from "../../renderer/CellRendererAcuActions";
import CellRendererAcuSlot from "../../renderer/CellRendererAcuSlot";
import CellRendererCloudStatus from "../../renderer/CellRendererCloudStatus";
import CellRendererStatus from "../../renderer/CellRendererStatus";
import CellRendererSynchStatus from "../../renderer/CellRendererSynchStatus.vue";

export default {
  props: {
    headers: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    AgGridVue,
    CellRendererAcuActions,
    CellRendererCloudStatus,
    CellRendererStatus,
    CellRendererSynchStatus,
    CellRendererAcuSlot

  },
  data() {
    return {
      count: 0,
      gridApi: null,
      gridColumnApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        lockPinned: true,
      },
      components: {
        CellRendererAcuActions,
        CellRendererCloudStatus,
        CellRendererStatus,
      },
      opacity_table: false,
      columnMoved: false,
    };
  },

  computed: {
    computedItems() {
      return this.items;
    },
  },

  methods: {
    onCellClicked(cell) {

      if (cell.column.colId !== "actions") {
        if (cell && cell.data && cell.data.status === "pending") {
          this.$vs.notify({
            time: 7000,
            color: "danger",
            title: "ACU is not activate",
          });
          return false
        }
        this.$vs.loading({
          type: "corners",
        });
        this.$emit("updateItem", cell.data);
        setTimeout(() => {
          this.$vs.loading.close();
        }, 200);
      }
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.autoSizeAll();
    },
    moved(event) {
      this.onColumnMoved(event)
    },
    onColumnMoved(event) {
      const newColumnOrder = this.gridColumnApi.getAllGridColumns().map(col => col.colDef.headerName);
      this.$emit('changeAcuHeadersOrdered', newColumnOrder);
    },
    handleWindowResize() {
      this.autoSizeAll();
    },
    autoSizeAll() {
      setTimeout(() => {
        this.gridApi.sizeColumnsToFit();
        this.opacity_table = true;
        this.$vs.loading.close();
      }, 100);
    },
  },
  mounted() {
    this.count = this.count + 1;
  },
  created() {
    window.addEventListener("resize", this.handleWindowResize);
    this.$root.$on("refreshAcuTable", () => {
      this.opacity_table = false;
      this.autoSizeAll();
      this.$vs.loading.close();
    });
  },
};
</script>
